import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import testimonialsman from '../images/testimonials man.png'
import mamu from '../images/MAMU.png'
import tristen from '../images/tristen.png'
import { useState } from "react";
import $ from 'jquery'



const Testimonials = () => {
let p = '< p >'
let pc = '< /p >'




 let [text , setText] = useState('check out testimonies below!!! by clicking the head or text besides it....');



 const handleClick = () =>{
    setText('"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit dolor non harum, placeat officiis facilis."');
    $('.Mamu .img-fluid').fadeOut(700);
    $('.Tristen .img-fluid').fadeIn(700);


 }
 const handleClicker = () => {
   setText('"Craig was a real pleasure to work with and I look forward to working with him again. He ISs definetly the kind of developer you can trust with a project from start to finish."');
   $('.Tristen .img-fluid').fadeOut(700);
   $('.Mamu .img-fluid').fadeIn(700);

 };

  return (
    <div>
       <Navbar/>
    <section class="testimonials">
    <div class="container">
           <div class="row">
                <div class="col-lg-8 col-md-12">
                    <div class="headerText">
                        <h2>Testimonials</h2>
                        <p>what clients say about me</p>
                    </div>

                    <div class="cards">
                        <div class="card-content">
                            <span> {p}</span>
                            <p>{text}</p>

                            <span> {pc}</span>
                          
                        </div>  
                                            
                </div>
                <div class="people col-md-12">
                    <div className="Tristen">
                    <img onClick={handleClicker} src={tristen} alt="tristens pic" class="img-fluid"/> 
                    <div class="line"></div>

                    </div>
                    <div className="Mamu">
                    <img onClick={handleClick}  src={mamu} alt="mamu's pic " class="img-fluid"/>
                    <div class="line"></div>

                    </div>
                    
                </div>  
                

           </div>


           <div class="col-lg-4 col-md-12">
            <div class="testimonials-img">
                <img src={testimonialsman} alt="testimonials man" class="img-fluid"/>
            </div>
           
            
            
        </div>

        
    </div>
    </div>

    </section>
    <Footer/>

    </div>
   

  );

};
export default Testimonials;
